/**
 * types.ts — contratos del admin-panel, tipados contra la respuesta REAL del API.
 */

export type UserRole = "admin" | "technician";

export interface Usuario {
  id: string;
  nombre: string;
  email: string;
  rol: UserRole;
  activo: boolean;
}

export interface NuevoUsuarioInput {
  nombre: string;
  email: string;
  password: string;
  rol: UserRole;
}

export interface CambiosUsuarioInput {
  nombre?: string;
  email?: string;
  rol?: UserRole;
  activo?: boolean;
  password?: string;
}

export interface Cliente {
  id: string;
  nombre: string;
  sigla: string;
  activo: boolean;
  createdAt: string;
}

export interface NuevoClienteInput {
  nombre: string;
  sigla?: string;
}

export interface CambiosClienteInput {
  nombre?: string;
  sigla?: string;
  activo?: boolean;
}

export const ROL_LABEL: Record<UserRole, string> = {
  admin: "Administrador",
  technician: "Técnico",
};

/** Identidad de la empresa (singleton). El API la devuelve en camelCase. */
export interface Marca {
  nombreComercial: string;
  tagline: string;
  direccion: string;
  telefonos: string;
  correo: string;
  sitioWeb: string;
  colorPrimario: string;
  colorAcento: string;
  /** Logo for dark surfaces (cover/header). Usually light/white. */
  logoUrl: string;
  /** Logo for light surfaces (closing signature). Usually dark. */
  logoUrlClaro: string;
}
